import { createComponent } from '@carvana/merch-components';

export const VehicleTileWrapper = createComponent('div', {
  className: 'w-[300px] u:h-full sm:w-[280px] lg:w-[300px]'
});
